import { connect } from 'react-redux';
import { useState, useEffect, useRef, useCallback } from 'react';
import { setAlert, siteboardAction, logout } from '../actions/defaultActions';
import { UserName, SET_NAME } from '../actions/types';

import ParallaxSection from './ParallaxSection';
import PushButton from './PushButton';

import Logo from '../SiteBoard_Logo';
import ExpandDownIcon from '../icons/expandDownIcon';

const SetupName = ({ _users, _userId, setAlert, siteboardAction, logout }) => {
  const getUserFirstName = useCallback(() => {
    try { return _users[_userId].firstName; } catch(error) { return ''; }
  }, [_users, _userId]);

  const getUserLastName = useCallback(() => {
    try { return _users[_userId].lastName; } catch(error) { return ''; }
  }, [_users, _userId]);

  const getUserEmail = useCallback(() => {
    try { return _users[_userId].email; } catch(error) { return ''; }
  }, [_users, _userId]);

  const firstNameRef = useRef(null);
  const [inputFirstName, setInputFirstName] = useState(getUserFirstName());
  const [inputLastName, setInputLastName] = useState(getUserLastName());

  const submitName = () => {
    try {
      const validFirstName = UserName.validate(inputFirstName, 'First name');
      if(validFirstName.length === 0) throw new Error('Please enter your first name');

      const validLastName = UserName.validate(inputLastName, 'Last name');
      if(validLastName.length === 0) throw new Error('Please enter your last name');

      const onSuccess = (output) => {};
      siteboardAction(SET_NAME, {
        firstName: inputFirstName,
        lastName: inputLastName,
      }, onSuccess);
    } catch(error) {
      setAlert(error.message);
    }
  };

  // focus input when component is shown
  useEffect(() => { 
    //firstNameRef.current.focus(); 
  }, []);

  return (
    <div className='relative flex flex-col justify-between w-screen h-screen justify-center items-center text-white overflow-hidden'>
      <div className='relative z-[2] w-full flex justify-between'>
        {/* SiteBoard logo */}
        <div className={'flex items-center gap-x-2 font-bold text-[1.8em] p-2'}>
          <Logo size={'1em'} />
          {process.env.REACT_APP_WEBSITE_NAME} 
        </div>
        <div className='max-w-[50vw]'>
          <div className='relative group mt-4 mr-4'>
            <div className='flex items-center gap-2 font-medium break-all text-right cursor-default'>
              <div>{getUserEmail()}</div>
              <div className='group-hover:scale-y-[-1]'><ExpandDownIcon /></div>
            </div>
            <div className='hidden absolute top-full right-0 w-full group-hover:block text-right p-2 animate-up-fade'>
              <button 
                className='text-white text-center px-4 py-2 rounded-lg bg-[#471cffbf] hover:bg-[#471cff] select-none font-bold'
                onClick={() => {
                  logout();
                }}
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className='relative grow flex flex-col justify-center z-[1] text-white px-4 animate-right-fade'>
        {/* name input */}
        <div className='flex flex-col gap-4 max-w-sm mx-auto'>
          <h1 className='flex flex-col gap-4 font-bold text-[2em] leading-[1em] mb-[1em]'>
            <div className='text-center'>Welcome</div>
            <div>Please enter your name to finish setting up your account</div>
          </h1>
          <div>
            <label className='block text-sm font-medium mb-1'>First Name</label>
            <input
              className='w-full text-white rounded-md px-3 py-1.5 bg-[#444247] hover:bg-[#656565] focus:bg-[#656565]' 
              type="text"
              value={inputFirstName}
              onChange={(event) => { setInputFirstName(event.target.value); }}
              onKeyDown={(event) => { if(event.key === 'Enter') { submitName(); } }}
            />
          </div>
          <div>
            <label className='block text-sm font-medium mb-1'>Last Name</label>
            <input
              className='w-full text-white rounded-md px-3 py-1.5 bg-[#444247] hover:bg-[#656565] focus:bg-[#656565]' 
              type="text"
              value={inputLastName}
              onChange={(event) => { setInputLastName(event.target.value); }}
              onKeyDown={(event) => { if(event.key === 'Enter') { submitName(); } }}
            />
          </div>
        </div>
        {/* submit name button */}
        <div className='mt-4'>
          <PushButton 
            textColor='white'
            bgColor='#471cff'
            hoverBgColor='#603aff'
            onClick={() => { submitName(); }}
          >
            Continue
          </PushButton>
        </div>
      </div>
      <div className='z-[0] absolute top-[0vh] left-[0vw] opacity-[1] pointer-events-none'>
        <ParallaxSection parallaxMultiplier={0.5}>
          {/*<img width='906' height='1000' className='h-[120vh] object-cover object-top' src='/images/constructionSite2.svg' alt='line drawing of a construction site' />*/}
          <img width='1536' height='1024' className='w-[100vw] min-h-[100vh] object-cover object-top' src='/images/constructionSite3.jpg' alt='a construction site' />
        </ParallaxSection>
      </div>
    </div>
  );
};

const mapStateToProps = state => { return {
  _users: state.serverSynced.users,
  _userId: state.localPersistent.userId,
}};
export default connect(mapStateToProps, { setAlert, siteboardAction, logout })(SetupName);
